import { ISuggestionsState } from '../../types/redux/suggestions';

export const DEFAULT_SUGGESTIONS_STATE: ISuggestionsState = {
  list: null,
  loading: false,
};
